import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers'

const store = createStore(rootReducer, applyMiddleware(thunk));

export function getStore(){ return store };
export function getDispatch(){ return getStore().dispatch }
export function getState(){ return store.getState() };
